import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import React, { useEffect } from 'react';
import { cnBem } from '@carnica/utils';
import { Button, ErrorOrEmptyBlock } from '@carnica/ui-kit';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';
import { useAppSelector } from "../../../../shared/model";
import { selectChatCofig, selectErrorScreenType } from "../../../../entities/settings/model";
import { ymPushSocketConnectionError, ymPushViewChatError } from "../../../../shared/analytics";
import { useErrorScreen } from "../../lib";
import { ErrorScreenType } from "../../../../shared/config";
import styles from "./styles.pcss";
var cnErrorScreen = cnBem('error-screen', styles);
export var ErrorScreen = function ErrorScreen(_ref) {
  var className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useAppSelector = useAppSelector(selectChatCofig),
    authZoneConfig = _useAppSelector.authZoneConfig;
  var screenType = useAppSelector(selectErrorScreenType);
  useEffect(function () {
    ymPushSocketConnectionError();
    ymPushViewChatError(authZoneConfig.zoneType);
  }, []);
  var _useErrorScreen = useErrorScreen(),
    content = _useErrorScreen.content,
    onUpdateClick = _useErrorScreen.onUpdateClick;
  return /*#__PURE__*/React.createElement("section", _extends({
    className: cnErrorScreen(null, [className])
  }, otherProps, {
    "data-t-id": "ui-ErrorScreen"
  }), /*#__PURE__*/React.createElement(ErrorOrEmptyBlock, _extends({
    className: cnErrorScreen('screen', {
      'only-title': !!(content !== null && content !== void 0 && content.isOnlyTitle)
    }),
    invert: true
  }, content), screenType !== ErrorScreenType.BLOCK && /*#__PURE__*/React.createElement(Button, {
    className: cnComponentsTheme('dark'),
    onClick: onUpdateClick,
    size: "m",
    view: "tertiary"
  }, "\u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C")));
};